/**
 * KERIS — Centralized interaction scripts
 * Favorites, remind-me, partner availability dialog, accordion specs, account tabs
 */
(function () {
  'use strict';

  var FAVORITES_KEY = 'keris-favorites';

  function readFavorites() {
    try { return JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]'); }
    catch (_) { return []; }
  }

  function writeFavorites(arr) {
    try { localStorage.setItem(FAVORITES_KEY, JSON.stringify(arr)); } catch (_) {}
  }

  function initFavorites() {
    document.querySelectorAll('[data-keris-favorite]').forEach(function (btn) {
      var product = btn.getAttribute('data-keris-favorite') || '';
      var label = btn.querySelector('[data-fav-label]');

      function sync() {
        var active = readFavorites().includes(product);
        btn.classList.toggle('is-active', active);
        if (label) label.textContent = active ? 'ADDED TO FAVOURITES' : 'ADD TO FAVOURITES';
      }

      btn.addEventListener('click', function () {
        var current = readFavorites();
        var next = current.includes(product)
          ? current.filter(function (p) { return p !== product; })
          : current.concat([product]);
        writeFavorites(next);
        sync();
      });

      sync();
    });
  }

  function getKerisMailtoInbox() {
    var dialog = document.getElementById('keris-partner-dialog');
    var raw = dialog ? dialog.getAttribute('data-fallback-inbox') : '';
    var v = (raw || '').trim();
    return v || 'keris@keris-time.com';
  }

  function initRemindMe() {
    document.querySelectorAll('[data-keris-remind]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var product = btn.getAttribute('data-keris-remind') || 'KERIS';
        if (typeof window.openKerisBrevoPopup === 'function') {
          window.openKerisBrevoPopup(product);
          return;
        }
        var inbox = getKerisMailtoInbox();
        var subject = 'Reminder — ' + product;
        var body =
          'Hello,\n\n' +
          'Please remind me when the following KERIS piece is available again:\n' +
          product +
          '\n\nThank you.';
        window.location.href =
          'mailto:' +
          inbox +
          '?subject=' +
          encodeURIComponent(subject) +
          '&body=' +
          encodeURIComponent(body);
      });
    });
  }

  /**
   * Retail partner list. Optional per entry:
   * inquiryEmail — inbox that receives this inquiry (EmailJS template "To" = {{to_email}}). If missing or invalid, data-fallback-inbox is used.
   */
  /* Partner list aligned with internal CSV (availability inquiry → partner inbox via EmailJS). */
  var PA_PARTNERS = [
    {
      name: 'Ahmed Seddiqi & Sons',
      address: 'Abu Dhabi, UAE',
      website: 'https://www.seddiqi.com',
      inquiryEmail: 'abdurahman.abdullah@seddiqi.com',
    },
    { name: 'Asia Jewellers', address: 'Manama, Bahrain', inquiryEmail: 'info@asiajewellers.com' },
    { name: "Burdeen's Jewelry", address: 'Chicago, USA', inquiryEmail: 'sales@burdeens.com' },
    { name: 'Ben Jannet', address: 'Tunis, Tunisie', inquiryEmail: 'contact@benjannetandco.com' },
    { name: 'Chronopassion', address: 'Paris, France', inquiryEmail: 'chronop@chronopassion.fr' },
    {
      name: 'Curiosity Store Genève',
      address: 'Geneva, Switzerland',
      inquiryEmail: 'INFO@curiosity-store.ch',
    },
    {
      name: 'Curiosity Store Lausanne',
      address: 'Lausanne, Switzerland',
      inquiryEmail: 'INFO@curiosity-store.ch',
    },
    { name: 'Modern Home', address: 'Doha, Qatar', inquiryEmail: 'kbadran@darwishholding.com' },
    { name: 'FIIFAA', address: 'Lagos, Nigeria', website: 'https://fiifaa.com/shop/', inquiryEmail: 'info@fiifaa.com' },
    { name: 'Manfredi Jewels', address: 'Greenwich, USA', inquiryEmail: 'Rob@manfredijewels.com' },
    { name: 'PONCINI Port Louis', address: 'Port Louis, Mauritius', inquiryEmail: 'contact@poncini.com' },
    { name: 'PISA', address: 'Milano, Italy', website: 'https://pisa1940.com/', inquiryEmail: 'flagshipstore@pisa1940.com' },
    {
      name: 'TIME+TIDE Watches AU',
      address: 'Melbourne, Australia',
      website: 'https://timeandtidewatches.com/',
      inquiryEmail: 'sean@timeandtidewatches.com',
    },
    {
      name: 'TIME+TIDE Watches UK',
      address: 'London, United Kingdom',
      website: 'https://timeandtidewatches.com/',
      inquiryEmail: 'sales@timeandtidewatches.co.uk',
    },
    {
      name: 'Time & Tide Watches Corp',
      address: 'New York, United States of America',
      website: 'https://timeandtidewatches.com/',
      inquiryEmail: 'sales@timeandtidewatches.com',
    },
    { name: 'Time Keeper', address: 'Kuwait City, Kuwait', inquiryEmail: 'cs@time-keeper.com' },
    { name: 'Premier Group', address: 'Almaty, Kazakhstan' },
    { name: 'Salon KANTIEM', address: 'Istanbul, Turquie' },
    { name: 'Swiss Prestige', address: 'Taipei, Taiwan', inquiryEmail: 'swiss.prestige@swissp.com' },
    { name: '10Ten Labs', address: 'Riyadh, Kingdom of Saudi Arabia', inquiryEmail: 'Info@10tenlabs.com' },
    { name: "Collector's House", address: 'Seoul, South Korea', inquiryEmail: 'sean@star-red.com' },
    { name: 'Maison Davis', address: 'Zermatt, Switzerland', inquiryEmail: 'zermatt.davis@gmail.com' },
    { name: 'Knar Jewellery', address: 'Guelph, Canada', inquiryEmail: 'umair.s@knar.com' },
    { name: 'Les Ambassadeurs', address: 'Luxembourg City, Luxembourg' },
    { name: 'AVRA CLOCK', address: 'Kiev, Ukraine', inquiryEmail: 'avraclock@gmail.com' },
    { name: 'Joyeria Roca', address: 'Caracas, Venezuela', inquiryEmail: 'sales@joyeriacaracas.com' },
    { name: 'Berger', address: 'Mexico City, Mexico' },
    { name: 'Casa Barros', address: 'Santiago, Chile', inquiryEmail: 'joyeria@casabarros.cl' },
    { name: 'Miami Outpost', address: 'Miami, Florida, USA', inquiryEmail: 'lucalacharlotte1@gmail.com' },
  ];

  function paGetCountry(address) {
    var parts = String(address || '').split(',');
    return (parts[parts.length - 1] || '').trim();
  }

  function paEscapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function loadKerisRetailersFromTheme() {
    var el = document.getElementById('keris-retailers-json');
    if (!el) return null;
    try {
      var arr = JSON.parse(el.textContent || '[]');
      return Array.isArray(arr) && arr.length ? arr : null;
    } catch (_e) {
      return null;
    }
  }

  function initPartnerAvailabilityDialog() {
    var dialog = document.getElementById('keris-partner-dialog');
    if (!dialog) return;

    var partnersList = loadKerisRetailersFromTheme() || PA_PARTNERS;

    var panel = dialog.querySelector('.keris-pa__panel');
    var stepFind = document.getElementById('keris-pa-step-find');
    var stepDetails = document.getElementById('keris-pa-step-details');
    var stepSuccess = document.getElementById('keris-pa-step-success');
    var intro = document.getElementById('keris-pa-intro');
    var countrySel = document.getElementById('keris-pa-country');
    var partnerWrap = document.getElementById('keris-pa-partner-wrap');
    var partnerSel = document.getElementById('keris-pa-partner');
    var actions = document.getElementById('keris-pa-actions');
    var hint = document.getElementById('keris-pa-hint');
    var btnNext = document.getElementById('keris-pa-next');
    var detailsIntro = document.getElementById('keris-pa-details-intro');
    var form = document.getElementById('keris-pa-form');
    var inpFirst = document.getElementById('keris-pa-firstname');
    var inpLast = document.getElementById('keris-pa-lastname');
    var inpEmail = document.getElementById('keris-pa-email');
    var inpPhone = document.getElementById('keris-pa-phone');
    var btnBack = document.getElementById('keris-pa-back');
    var btnSubmit = document.getElementById('keris-pa-submit');
    var errEl = document.getElementById('keris-pa-error');
    var successBody = document.getElementById('keris-pa-success-body');

    var productName = '';
    var lastFocus = null;
    var selectedPartner = null;

    var emailjsPk = (dialog.getAttribute('data-emailjs-public-key') || '').trim();
    var emailjsSid = (dialog.getAttribute('data-emailjs-service-id') || '').trim();
    var emailjsTid = (dialog.getAttribute('data-emailjs-template-id') || '').trim();
    var emailjsAdminTid = (dialog.getAttribute('data-emailjs-admin-template-id') || '').trim();
    var fallbackInbox = (dialog.getAttribute('data-fallback-inbox') || 'keris@keris-time.com').trim();
    var googleSheetUrl = (dialog.getAttribute('data-google-sheet-url') || '').trim();

    /** Partner store inbox, or theme fallback if inquiryEmail not set. */
    function getPartnerInquiryInbox(p) {
      if (!p) return fallbackInbox;
      var raw = p.inquiryEmail;
      var e = raw == null ? '' : String(raw).trim();
      if (e && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) return e;
      return fallbackInbox;
    }

    var countries = [];
    var seen = {};
    partnersList.forEach(function (p) {
      var c = paGetCountry(p.address);
      if (c && !seen[c]) {
        seen[c] = true;
        countries.push(c);
      }
    });
    countries.sort();

    function fillCountries() {
      countrySel.innerHTML = '<option value="">Select a country</option>';
      countries.forEach(function (c) {
        var opt = document.createElement('option');
        opt.value = c;
        opt.textContent = c;
        countrySel.appendChild(opt);
      });
    }

    function showStep(which) {
      if (stepFind) stepFind.hidden = which !== 'find';
      if (stepDetails) stepDetails.hidden = which !== 'details';
      if (stepSuccess) stepSuccess.hidden = which !== 'success';
      if (which === 'find' && panel && panel.focus) {
        try {
          panel.focus();
        } catch (_e) {}
      }
      if (which === 'details' && inpFirst) {
        setTimeout(function () {
          try {
            inpFirst.focus();
          } catch (_e2) {}
        }, 50);
      }
    }

    function resetPartnerUi() {
      partnerSel.innerHTML = '<option value="">Select a partner</option>';
      partnerWrap.hidden = true;
      actions.hidden = true;
      while (hint.firstChild) hint.removeChild(hint.firstChild);
      if (btnNext) btnNext.disabled = true;
      selectedPartner = null;
    }

    function syncSubmitEnabled() {
      if (!btnSubmit || !inpFirst || !inpLast || !inpEmail || !inpPhone) return;
      var phoneDigits = inpPhone.value.trim().replace(/\D/g, '');
      var ok =
        inpFirst.value.trim().length > 0 &&
        inpLast.value.trim().length > 0 &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inpEmail.value.trim()) &&
        phoneDigits.length >= 6;
      btnSubmit.disabled = !ok;
    }

    /** Strip newlines for safe single-line fields. */
    function sanitizeOneLine(s) {
      return String(s == null ? '' : s).replace(/[\r\n]+/g, ' ').trim();
    }

    /**
     * Full letter text for EmailJS admin (inquiry_body) and mailto fallback.
     */
    function buildCustomerInquiryMessage(firstName, lastName, phone, prod) {
      var fullName = (sanitizeOneLine(firstName) + ' ' + sanitizeOneLine(lastName)).trim();
      var phoneLine = sanitizeOneLine(phone);
      return (
        'Dear Team,\n' +
        'I hope this message finds you well.\n\n' +
        'I would appreciate it if you could kindly share the KERIS pieces you currently have available.\n' +
        'I am particularly interested in the following model(s): ' +
        prod +
        '.\n\n' +
        'I would also be grateful for any details regarding availability, pricing, and delivery timelines.\n\n' +
        'Thank you very much for your time and assistance.\n\n' +
        'Kind regards,\n' +
        fullName +
        (phoneLine ? '\nPhone: ' + phoneLine : '')
      );
    }

    function openMailtoFallback(p, firstName, lastName, email, phone) {
      var prod = sanitizeOneLine(productName);
      var subject = 'Inquiry about KERIS piece';
      var body = buildCustomerInquiryMessage(firstName, lastName, phone, prod);
      var to = encodeURIComponent(getPartnerInquiryInbox(p));
      window.location.href =
        'mailto:' +
        to +
        '?subject=' +
        encodeURIComponent(subject) +
        '&body=' +
        encodeURIComponent(body);
    }

    /**
     * Sends the inquiry to your inbox; template body should be only {{inquiry_body}} (plus subject / reply_to as needed).
     */
    function sendEmailJsAdminInquiry(p, firstName, lastName, email, phone, honeypot) {
      if (honeypot) {
        return Promise.reject(new Error('Blocked'));
      }
      if (!emailjsPk || !emailjsSid || !emailjsAdminTid) {
        return Promise.reject(new Error('EmailJS admin template not configured'));
      }
      var prod = sanitizeOneLine(productName);
      var visitorEmail = email.trim();
      var visitorPhone = sanitizeOneLine(phone);
      var partnerInbox = getPartnerInquiryInbox(p);
      var params = {
        inquiry_body: buildCustomerInquiryMessage(firstName, lastName, phone, prod),
        to_email: partnerInbox,
        reply_to: visitorEmail,
        customer_email: visitorEmail,
        user_email: visitorEmail,
        customer_phone: visitorPhone,
        customer_name: sanitizeOneLine(firstName) + ' ' + sanitizeOneLine(lastName),
        product_name: productName,
        partner_name: p.name,
        partner_address: p.address,
        partner_inbox_email: partnerInbox,
      };
      return fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          service_id: emailjsSid,
          template_id: emailjsAdminTid,
          user_id: emailjsPk,
          template_params: params,
        }),
      }).then(function (r) {
        return r.text().then(function (t) {
          if (!r.ok) throw new Error(t || 'EmailJS admin send failed');
        });
      });
    }

    function sendEmailJsConfirmation(p, firstName, lastName, email, phone) {
      if (!emailjsPk || !emailjsSid || !emailjsTid) {
        return Promise.resolve({ skipped: true });
      }
      var params = {
        customer_name: firstName.trim() + ' ' + lastName.trim(),
        customer_email: email.trim(),
        customer_phone: sanitizeOneLine(phone),
        product_name: productName,
        partner_name: p.name,
        partner_address: p.address,
        to_email: email.trim(),
        reply_to: email.trim(),
      };
      return fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          service_id: emailjsSid,
          template_id: emailjsTid,
          user_id: emailjsPk,
          template_params: params,
        }),
      }).then(function (r) {
        return r.text().then(function (t) {
          if (!r.ok) throw new Error(t || 'EmailJS error');
          return { skipped: false };
        });
      });
    }

    function sendToGoogleSheet(p, firstName, lastName, email, phone) {
      if (!googleSheetUrl) return Promise.resolve({ skipped: true });
      var payload = {
        customer_name: sanitizeOneLine(firstName) + ' ' + sanitizeOneLine(lastName),
        customer_email: email.trim(),
        customer_phone: sanitizeOneLine(phone),
        product_name: productName,
        partner_name: p.name,
        partner_address: p.address,
        partner_inbox_email: getPartnerInquiryInbox(p),
      };
      return fetch(googleSheetUrl, {
        method: 'POST',
        body: JSON.stringify(payload),
      }).then(function (r) {
        if (!r.ok) throw new Error('Google Sheet: ' + r.status);
      }).catch(function () {});
    }

    function open(name) {
      productName = (name || 'KERIS').trim() || 'KERIS';
      lastFocus = document.activeElement;
      intro.textContent =
        'Select your country and a partner to inquire about ' + productName + ' availability.';
      countrySel.value = '';
      resetPartnerUi();
      fillCountries();
      if (form) form.reset();
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = '';
      }
      showStep('find');
      dialog.hidden = false;
      dialog.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (panel && panel.focus) panel.focus();
    }

    function close() {
      dialog.hidden = true;
      dialog.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      showStep('find');
      if (form) form.reset();
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = '';
      }
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try {
          lastFocus.focus();
        } catch (_e) {}
      }
    }

    function onCountryChange() {
      var c = countrySel.value;
      partnerSel.innerHTML = '<option value="">Select a partner</option>';
      if (!c) {
        partnerWrap.hidden = true;
        actions.hidden = true;
        while (hint.firstChild) hint.removeChild(hint.firstChild);
        if (btnNext) btnNext.disabled = true;
        selectedPartner = null;
        return;
      }
      partnerWrap.hidden = false;
      partnersList.forEach(function (p, i) {
        if (paGetCountry(p.address) !== c) return;
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = p.name + ' — ' + p.address;
        partnerSel.appendChild(opt);
      });
      partnerSel.value = '';
      actions.hidden = true;
      while (hint.firstChild) hint.removeChild(hint.firstChild);
      if (btnNext) btnNext.disabled = true;
      selectedPartner = null;
    }

    function onPartnerChange() {
      var idx = partnerSel.value;
      while (hint.firstChild) hint.removeChild(hint.firstChild);
      if (!idx) {
        actions.hidden = true;
        if (btnNext) btnNext.disabled = true;
        selectedPartner = null;
        return;
      }
      var p = partnersList[parseInt(idx, 10)];
      if (!p) return;
      selectedPartner = p;
      actions.hidden = false;
      if (btnNext) btnNext.disabled = false;
      hint.appendChild(document.createTextNode('Continue to enter your details for '));
      var s1 = document.createElement('strong');
      s1.textContent = productName;
      hint.appendChild(s1);
      hint.appendChild(document.createTextNode(' at '));
      var s2 = document.createElement('strong');
      s2.textContent = p.name;
      hint.appendChild(s2);
      hint.appendChild(document.createTextNode('.'));
    }

    function goToDetails() {
      if (!partnerSel.value || !selectedPartner) return;
      var p = selectedPartner;
      detailsIntro.innerHTML =
        'Inquire about <strong>' +
        paEscapeHtml(productName) +
        '</strong> at <strong>' +
        paEscapeHtml(p.name) +
        '</strong>.';
      showStep('details');
      syncSubmitEnabled();
    }

    function goBackToFind() {
      showStep('find');
    }

    function onFormSubmit(e) {
      e.preventDefault();
      if (!selectedPartner || !inpFirst || !inpLast || !inpEmail || !inpPhone) return;
      var hp = form.querySelector('.keris-pa__honeypot');
      if (hp && hp.value) return;

      var firstName = inpFirst.value;
      var lastName = inpLast.value;
      var email = inpEmail.value.trim();
      var phone = inpPhone.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errEl) {
          errEl.textContent = 'Please enter a valid email address.';
          errEl.hidden = false;
        }
        return;
      }
      if (phone.replace(/\D/g, '').length < 6) {
        if (errEl) {
          errEl.textContent = 'Please enter a valid phone number.';
          errEl.hidden = false;
        }
        return;
      }
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = '';
      }

      var p = selectedPartner;
      var hasEmailJsAdmin = emailjsPk && emailjsSid && emailjsAdminTid;

      if (hasEmailJsAdmin) {
        btnSubmit.classList.add('is-loading');
        btnSubmit.disabled = true;
        sendToGoogleSheet(p, firstName, lastName, email, phone);
        sendEmailJsAdminInquiry(p, firstName, lastName, email, phone, hp && hp.value)
          .then(function () {
            return sendEmailJsConfirmation(p, firstName, lastName, email, phone).catch(function () {
              return { skipped: true };
            });
          })
          .then(function (ej) {
            var fn = paEscapeHtml(firstName.trim());
            var confirmationSent = ej && ej.skipped === false;
            var extra =
              confirmationSent
                ? '<p>A confirmation email has been sent to <strong>' +
                  paEscapeHtml(email) +
                  '</strong>.</p><p class="keris-pa__success-note">If you do not see it within a few minutes, please check your spam folder.</p>'
                : '<p>We will contact you at <strong>' +
                  paEscapeHtml(email) +
                  '</strong> shortly.</p>';
            successBody.innerHTML =
              '<p>Thank you, <strong>' +
              fn +
              '</strong>.</p><p>We have received your inquiry about <strong>' +
              paEscapeHtml(productName) +
              '</strong> at <strong>' +
              paEscapeHtml(p.name) +
              '</strong>.</p>' +
              extra;
            showStep('success');
          })
          .catch(function (err) {
            if (errEl) {
              errEl.textContent =
                (err && err.message) ||
                'Something went wrong. Please try again or email us directly.';
              errEl.hidden = false;
            }
          })
          .finally(function () {
            btnSubmit.classList.remove('is-loading');
            syncSubmitEnabled();
          });
        return;
      }

      sendToGoogleSheet(p, firstName, lastName, email, phone);
      openMailtoFallback(p, firstName, lastName, email, phone);
      successBody.innerHTML =
        '<p>If your email app opened, send the message to complete your inquiry. For silent delivery without opening the mail app, add EmailJS public key, service ID, and admin inbox template in Theme settings.</p>';
      showStep('success');
    }

    fillCountries();
    countrySel.addEventListener('change', onCountryChange);
    partnerSel.addEventListener('change', onPartnerChange);

    if (btnNext) {
      btnNext.addEventListener('click', function () {
        goToDetails();
      });
    }
    if (btnBack) {
      btnBack.addEventListener('click', function () {
        goBackToFind();
      });
    }
    if (form) {
      form.addEventListener('submit', onFormSubmit);
    }
    [inpFirst, inpLast, inpEmail, inpPhone].forEach(function (el) {
      if (el) {
        el.addEventListener('input', syncSubmitEnabled);
        el.addEventListener('blur', syncSubmitEnabled);
      }
    });

    dialog.querySelectorAll('[data-keris-pa-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !dialog.hidden) {
        e.preventDefault();
        close();
      }
    });

    document.querySelectorAll('[data-keris-partner-dialog]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var name = btn.getAttribute('data-keris-partner-dialog') || 'KERIS';
        open(name);
      });
    });
  }

  function initAccountTabs() {
    var container = document.querySelector('[data-keris-account]');
    if (!container) return;

    var tabs = container.querySelectorAll('[data-keris-tab]');
    var panels = container.querySelectorAll('[data-keris-panel]');
    var mobileToggle = container.querySelector('[data-keris-mobile-toggle]');
    var mobileMenu = container.querySelector('[data-keris-mobile-menu]');
    var mobileLabel = container.querySelector('[data-keris-mobile-label]');

    function activate(key) {
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-keris-tab') === key);
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-keris-panel') !== key;
      });
      if (mobileLabel) {
        var activeTab = container.querySelector('[data-keris-tab="' + key + '"]');
        if (activeTab) mobileLabel.textContent = activeTab.textContent.trim();
      }
      if (mobileMenu) mobileMenu.hidden = true;
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-keris-tab'));
      });
    });

    if (mobileToggle && mobileMenu) {
      mobileToggle.addEventListener('click', function () {
        mobileMenu.hidden = !mobileMenu.hidden;
      });
    }

    var first = container.querySelector('[data-keris-tab]');
    if (first) activate(first.getAttribute('data-keris-tab'));
  }

  function initEditionsTabs() {
    var root = document.querySelector('[data-keris-editions]');
    if (!root) return;

    var subbar = root.querySelector('[data-keris-editions-subbar]');
    var panel = root.querySelector('[data-keris-editions-panel]');
    var ready = false;

    function reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function replayPanel() {
      if (!ready || !panel || reduceMotion()) return;
      panel.classList.remove('is-entering');
      void panel.offsetWidth;
      panel.classList.add('is-entering');
    }

    function setMainTab(key) {
      root.setAttribute('data-active-tab', key);
      root.querySelectorAll('[data-keris-editions-tab]').forEach(function (btn) {
        var on = btn.getAttribute('data-keris-editions-tab') === key;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-keris-editions-aside]').forEach(function (aside) {
        var ak = aside.getAttribute('data-keris-editions-aside');
        aside.setAttribute('aria-hidden', ak === key ? 'false' : 'true');
      });
      if (subbar) {
        subbar.hidden = false;
        subbar.classList.toggle('is-open', key === 'focus');
      }
    }

    function setSubTab(key) {
      root.setAttribute('data-active-subtab', key);
      root.querySelectorAll('[data-keris-editions-subtab]').forEach(function (btn) {
        var on = btn.getAttribute('data-keris-editions-subtab') === key;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    root.querySelectorAll('[data-keris-editions-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-keris-editions-tab') || 'meca';
        var currentMain = root.getAttribute('data-active-tab');
        var currentSub = root.getAttribute('data-active-subtab');
        if (key === 'focus') setSubTab('winding');
        var unchanged = currentMain === key && (key !== 'focus' || currentSub === 'winding');
        setMainTab(key);
        if (!unchanged) replayPanel();
      });
    });
    root.querySelectorAll('[data-keris-editions-subtab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-keris-editions-subtab') || 'winding';
        if (root.getAttribute('data-active-subtab') === key) return;
        setSubTab(key);
        replayPanel();
      });
    });

    setMainTab(root.getAttribute('data-active-tab') || 'meca');
    setSubTab(root.getAttribute('data-active-subtab') || 'winding');
    ready = true;
  }

  function init() {
    initFavorites();
    initRemindMe();
    initAccountTabs();
    initPartnerAvailabilityDialog();
    initEditionsTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
